export default function assumeType<T>(x: unknown): asserts x is T {
  return; // ¯\_(ツ)_/¯
}
